import { render, staticRenderFns } from "./InvoiceApplication.vue?vue&type=template&id=38801ec0&scoped=true&"
import script from "./InvoiceApplication.vue?vue&type=script&lang=js&"
export * from "./InvoiceApplication.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceApplication.vue?vue&type=style&index=0&id=38801ec0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38801ec0",
  null
  
)

export default component.exports